import { defaultTo } from 'ramda';
import type { IConfig } from '@cian/config/shared';

export const getTooltipText = (config: IConfig) => {
  return defaultTo('', config.get<string>('moderation.QualityLevelTooltip'));
};
